import { createFileRoute } from '@tanstack/react-router'

import { preloadListBusinessCards } from '@/api/react-query'
import { paginatedSearchWithSort } from '@/utils/route-utilities'

export const Route = createFileRoute('/_authenticated/_general/business-cards')({
	validateSearch: paginatedSearchWithSort(['name', 'cardNumber', 'status', 'externalId']),
	loaderDeps: ({ search: { limit, offset, q, sortBy, sortOrder } }) => ({
		limit,
		offset,
		q,
		sortBy,
		sortOrder
	}),
	loader: async ({ context, deps: { limit, offset, q, sortBy, sortOrder } }) =>
		await preloadListBusinessCards(context, {
			query: {
				limit,
				offset,
				q,
				sortBy,
				sortOrder
			}
		}),
	staticData: {
		crumb: ({ context: { L } }) => L.BusinessCards.Title()
	}
})
